export const REPROCESSING_INVOICE_ORDER_BY = [
  'created_on',
  'process_finished_on',
] as const;

export const REPROCESSING_INVOICE_CHANNEL = [
  'admin_upload',
  'api',
  'email',
  'test',
] as const;

export const REPROCESSING_INVOICE_STATUS = [
  'ai_data_error',
  'ai_parsing_error',
  'ambiguous_ai_files_error',
  'ambiguous_files_error',
  'automatically_forwarded',
  'company_matching_error',
  'delayed',
  'directly_forwarded',
  'done',
  'handed_off',
  'handoff_failed',
  'in_process',
  'invalid_attachments_error',
  'invalid_azure_response_error',
  'invoice_data_error',
  'invoice_process_stopper_error',
  'manually_dismissed',
  'no_ai_model_settings_error',
  'no_parser_found_error',
  'unauthorized_sender_error',
  'unknown_auto_forwarding_receiver_error',
  'unknown_error',
  'unknown_receiver_error',
  'waiting_for_add_email',
  'waiting_for_ai_parsing',
  'waiting_for_attaching_mail_to_process',
  'waiting_for_auto_forwarding',
  'waiting_for_invoice_service_handoff',
  'waiting_for_parsing',
  'waiting_for_sending',
  'failed_to_send_mail_error',
  'failed_to_attach_mail_to_process_error',
] as const;
